/**
 * Must be the first import in main.tsx: route modules build DateTimeFormats
 * at load time, and ESM evaluates imports in order. See
 * `installStaleTzdataShim` for why this exists and when to delete it.
 */
import { installStaleTzdataShim } from "@gately/validators";

installStaleTzdataShim();
